import { React, useEffect, useState, useRef } from "react";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { Navigation, Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import SVGIcons from '../../../assets/images/icons/svgIcons';

import './offPlanProperties.scss';
import ContactPopup from '../../ContactPopup/ContactPopup';
import ApiCaller from "../../../services/api/APICaller";
import { showSnackbar } from "../../Notification/Snackbar";
import S3ImageViewerWithFallback from "../../awsS3ImageViewer/ImgViewerWithFallback";



function OffPlanProperties() {

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  /**
  the legendary use effect function
  This will run very first on render
   */
  useEffect(() => {
    getDataArr();
  }, [])

  const getDataArr = () => {
    const apiCaller = new ApiCaller('off-plan/our-off-plans?status=active');
    apiCaller.getList().then(({ data }) => {
      setData(data.result)
    })
      .catch(() => showSnackbar().failure('Something went wrong'))
      .finally(() => setIsLoading(false));
  }

const [multipliedData, setMultipliedData] = useState([]);

  useEffect(() => {
    if (data.length > 2) {
      setMultipliedData([...data, ...data, ...data]);
    } else {
      setMultipliedData([...data]);
    }
  }, [data]);




  // eslint-disable-next-line react/prop-types
  const CustomPrevButton = ({ onClick }) => (
    <button type='button' className="swiper-button-prev offPlan-nav" onClick={onClick}>
      <SVGIcons.LeftArrowIcon />
    </button>
  );
  // eslint-disable-next-line react/prop-types
  const CustomNextButton = ({ onClick }) => (
    <button type='button' className="swiper-button-next offPlan-nav" onClick={onClick}>
      <SVGIcons.RightArrowIcon />
    </button>
  );
  const swiperRef = useRef(null);


  return (
    <>{(isLoading) ? "Loading Off-Plan properties" :
      <>
        {(!isLoading && data?.length === 0) ? "No Results found" :
          <div className='offPlan-slider f-wrp'>
            <Swiper
              onSwiper={(swiper) => { swiperRef.current = swiper; }}
              modules={[Navigation, Autoplay, Pagination]}
              spaceBetween={30}
              initialSlide={2}
              // slidesPerView={2.5}
              // centeredSlides={true}
              grabCursor={true}
              pagination={{
                el: '.swiper-pagination-custom',
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
              }}
              className='offPlan-property-slider f-wrp'
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  navigation: true,
                  autoplay: true,
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                  navigation: true,
                  autoplay: true,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                  navigation: true,
                  autoplay: true,
                },
                1024: {
                  slidesPerView: 2.3,
                  spaceBetween: 20,
                  navigation: true,
                },
                1275: {
                  slidesPerView: 2.3,
                  spaceBetween: 30,
                  navigation: true,
                  autoplay: false,
                },
              }}
              style={{
                paddingLeft: '13%',
                // paddingRight: '5%',
              }}
            >
              {multipliedData?.map((element, key) => (
                <SwiperSlide key={key} className={`${element.className}`}>
                  <div className="each-property-items f-wrp" key={key}>
                    {/* {element.name ? <ContactPopup
                      defaultComment={element.name} /> : null}
                    <span><img src={element.teamMemberImage} alt={element.name} /></span> */}
                    {element.title ? <ContactPopup
                      defaultComment={`I'm interested in ${element.title}.. `} /> : null}
                    <span><S3ImageViewerWithFallback fileKey={element.imageURL} /></span>
                  </div>


                </SwiperSlide>
              ))}
            </Swiper>
            <div className="swiper-pagination-custom offPlan-bullet" style={{ paddingTop: '50px' }} />
            <CustomPrevButton onClick={() => swiperRef.current.slidePrev()} />
            <CustomNextButton onClick={() => swiperRef.current.slideNext()} />
          </div>
        }
      </>
    }

    </>
  );
}

export default OffPlanProperties;